/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export const platformCompanySegment = 'platform-company';
export const platformAdminSegment = 'platform-administration';
export const platformAdminLeSubscriptionSegment = 'le-subscription';
export const workflows = 'workflows';
export const platformInvoicesSegment = 'invoices';
export const markPlatformInvoiceAsPaidSegment = 'mark-as-paid';
export const invalidateLeSegment = 'invalidate';
export const reactivateLeSegment = 'reactivate';
export const budgetManagementSegment = 'budget-management';
export const contactPlatformCompany = 'contact-platform-company';
export const errorSegment = 'error';
export const infoSegment = 'info';
export const gdprTermsAndConditionsSegment = 'gdpr-terms-and-conditions';
